import {GetItemCounts, SignatureType, useInfiniteSignatures} from "@twigsby/client-data";
import {
    ContentBlock,
    ContentLoader,
    FlexGap, InfiniteLoadTrigger,
    Modal,
    ModalSize,
    ModalType,
    StackHorizontal,
    useLayout
} from "@twigsby/frontend-framework";
import React, {useEffect, useState} from "react";

const SelectSignatureForBatchModal = (props: ModalType) => {
    const { theme } = useLayout();
    const { data, status, error, fetchNextPage, isFetchingNextPage, hasNextPage } = useInfiniteSignatures();

    const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 } );

    const HandleSignatureSelection = (signature: SignatureType) => {
        if(props.actionedCallback) {
            props.actionedCallback(signature);
            props.closeCallback();
        }
    }

    useEffect(() => {
        if(data) {
            setItemCounts(GetItemCounts(data as any));
        }
    }, [data]);

    return (
        <Modal title={'Select Digital Signature'} isOpen={props.isOpen} modalSize={ModalSize.Medium} closeCallback={props.closeCallback}>
            {status === 'loading' ? (
                <ContentLoader childHeight={'6em'} childCount={6} />
            ) : status === "error" ? (
                <ContentBlock error={true} title={error.name} content={error.message} />
            ) : (
                <>
                    <StackHorizontal gap={FlexGap.Medium} wrap={true}>
                        {data.pages.map((group, groupIndex) =>
                            group.data.map((signature, index) => {
                                if(!signature.value) return null;
                                return (
                                    <div
                                        key={`signature${groupIndex}${index}`}
                                        className={'signature-entry'}
                                        onClick={() => HandleSignatureSelection(signature)}
                                        role={'button'}
                                    >
                                        <img
                                            src={signature.value}
                                            alt={`Signature ${index + 1}`}
                                            style={{ filter: theme === 'dark' ? 'invert(1)' : 'none' }}
                                        />
                                    </div>
                                )
                            })
                        )}
                    </StackHorizontal>

                    {itemCounts.total > 0 && (
                        <InfiniteLoadTrigger
                            loaded={itemCounts.loaded}
                            totalCount={itemCounts.total}
                            hasNextPage={hasNextPage}
                            fetchNextPage={fetchNextPage}
                            isFetchingNextPage={isFetchingNextPage}
                        />
                    )}
                </>
            )}
        </Modal>
    )
}

export { SelectSignatureForBatchModal }
